import key from 'weak-key';
import YoutubeInfiniteGrid from '~/components/infiniteGrid/youtubeInfiniteGrid';

/**
 * Block Parser
 * @category Functional Component
 * @summary A catch all for all custom blocks, pair this with the getBlocksFromQueue data util for block based glory.
 * @prop {Object} blocks - The block items.
 * @prop {Object} drupalSettings - The drupal settings.
 * @prop {Object} recommendations - The recomentations for featured videos settings.
 * @return {Node} React node containing the blocks.
 */

const youtubeBlockParser = props => {
  const { youtubePlaylists } = props;
  return (
    <>
      {youtubePlaylists.map((blockItem) =>
        <div key={`block-item-${key(blockItem)}`}>
          <YoutubeInfiniteGrid content={ blockItem } />
        </div>
      )}
    </>
  );
}

export default youtubeBlockParser;
